module.exports = __webpack_public_path__ + "img/img_9.7ffa89ea.png";